webpackJsonp([6],{

/***/ 811:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(926)
}
var Component = __webpack_require__(15)(
  /* script */
  __webpack_require__(874),
  /* template */
  __webpack_require__(970),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 817:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(818), __esModule: true };

/***/ }),

/***/ 818:
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(8);
var $JSON = core.JSON || (core.JSON = { stringify: JSON.stringify });
module.exports = function stringify(it) { // eslint-disable-line no-unused-vars
  return $JSON.stringify.apply($JSON, arguments);
};


/***/ }),

/***/ 874:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(817);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import auth from './auth'

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},
  data: function data() {
    return {
      nofields: false,
      loader: false,
      successmessage: false,
      errormessage: false,
      contactFormFields: {
        name: "",
        email: "",
        profession: "",
        organization: "",
        newsletter: false,
        category: "",
        feedback: ""
      },
      error: false
    };
  },

  methods: {
    validFields: function validFields(field) {
      var re = /(.*[a-z]){3}/i;
      return re.test(field);
    },
    validEmail: function validEmail(email) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },

    conformSend: function conformSend() {
      var _this = this;

      // this.loader = true;
      var headers = {
        Authorization: "Bearer 054d817a3b1a3a2c5edf656959334969e1264e84"
      };
      if (this.validFields(this.contactFormFields.name) && this.validFields(this.contactFormFields.profession) && this.validEmail(this.contactFormFields.email) && this.validFields(this.contactFormFields.feedback)
      // this.contactFormFields.name != "" ||
      // this.contactFormFields.email != "" ||
      // this.contactFormFields.profession != ""
      ) {
          this.loader = true;
          this.errormessage = false;
          if (this.contactFormFields.name && this.contactFormFields.email && this.contactFormFields.profession && this.contactFormFields.category) {
            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("http://135.181.212.168:9234/api/account/contact/", this.contactFormFields, { headers: headers }).then(function (response) {
              console.log(_this.apiFormat(_this.contactFormFields));

              if (response.status === 201) {
                _this.successmessage = true;
                _this.loader = false;
                _this.contactFormFields.name = "";
                _this.contactFormFields.email = "";
                _this.contactFormFields.profession = "";
                _this.contactFormFields.newsletter = false;
                _this.contactFormFields.organization = "";
                _this.contactFormFields.feedback = "";
                _this.contactFormFields.category = "";
              } else {
                _this.loader = false;
                _this.errormessage = true;
              }
            }).catch(function (e) {
              console.log(e);
              _this.errormessage = true;
              _this.loader = false;
            });
            // console.log("testing form");
          }
        } else {
        this.nofields = true;
      }
    },
    apiFormat: function apiFormat(value) {
      var parentArray = [];
      var childArray = [];
      childArray.push(value.name, value.email, value.profession, value.organization, value.category, value.feedback, value.newsletter);
      parentArray.push(childArray);
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ data: parentArray });
    },
    navigateToCentralAnalytics: function navigateToCentralAnalytics() {
      this.$router.push("central_analytics");
    }
  }
});

/***/ }),

/***/ 905:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(802)(true);
// imports


// module
exports.push([module.i, ".error{color:red}.back-to-car-icon{top:105px}", "", {"version":3,"sources":["/var/www/msdat-dashboard/src/components/dashboards/car/mainCar/contact.vue"],"names":[],"mappings":"AACA,OACE,SAAW,CACZ,AACD,kBACE,SAAW,CACZ","file":"contact.vue","sourcesContent":["\n.error {\n  color: red;\n}\n.back-to-car-icon {\n  top: 105px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 926:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(905);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(803)("183ea1c0", content, true, {});

/***/ }),

/***/ 970:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-4 col-md-12"
  }, [_c('div', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.right",
      value: ('Back to platform'),
      expression: "'Back to platform'",
      modifiers: {
        "right": true
      }
    }],
    staticClass: "back-to-car-icon",
    on: {
      "click": _vm.navigateToCentralAnalytics
    }
  }, [_c('v-icon', {
    staticClass: "back-to-car-icon-v",
    staticStyle: {
      "color": "white"
    }
  }, [_vm._v("arrow_back")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "container",
    staticStyle: {
      "margin-top": "5px",
      "max-width": "558px"
    }
  }, [_c('h2', {
    staticClass: "text-center"
  }, [_vm._v("Contact Us")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "max-width": "558px"
    }
  }, [_c('div', {
    staticClass: "col"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.conformSend()
      }
    }
  }, [_c('div', {}, [_c('div', {}, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.nofields),
      expression: "nofields"
    }],
    staticClass: "alert alert-warning"
  }, [_vm._v("\n                  The following fields are required Name, Email Address and\n                  Profession\n                ")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.successmessage),
      expression: "successmessage"
    }],
    staticClass: "alert alert-success",
    attrs: {
      "align": "center"
    }
  }, [_vm._v("\n                  Thank you for contacting us\n                ")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errormessage),
      expression: "errormessage"
    }],
    staticClass: "alert alert-danger"
  }, [_vm._v("\n                  An error occured, please try again later\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contactFormFields.name),
      expression: "contactFormFields.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Name *",
      "required": "",
      "minlength": "4"
    },
    domProps: {
      "value": (_vm.contactFormFields.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.contactFormFields, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contactFormFields.email),
      expression: "contactFormFields.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "placeholder": "Email address *",
      "required": "",
      "email": ""
    },
    domProps: {
      "value": (_vm.contactFormFields.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.contactFormFields, "email", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contactFormFields.profession),
      expression: "contactFormFields.profession"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Profession or Field or Work/Study *",
      "required": ""
    },
    domProps: {
      "value": (_vm.contactFormFields.profession)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.contactFormFields, "profession", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contactFormFields.organization),
      expression: "contactFormFields.organization"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Organization"
    },
    domProps: {
      "value": (_vm.contactFormFields.organization)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.contactFormFields, "organization", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contactFormFields.category),
      expression: "contactFormFields.category"
    }],
    staticClass: "form-control",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.contactFormFields, "category", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select a Category *")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Suggestions"
    }
  }, [_vm._v("Suggestions")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Complaints"
    }
  }, [_vm._v("Complaints")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Ideas"
    }
  }, [_vm._v("Ideas")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "General Feedback"
    }
  }, [_vm._v("General Feedback")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contactFormFields.feedback),
      expression: "contactFormFields.feedback"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "placeholder": "Type your feedback...",
      "rows": "4"
    },
    domProps: {
      "value": (_vm.contactFormFields.feedback)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.contactFormFields, "feedback", $event.target.value)
      }
    }
  }, [_vm._v("feedback")])]), _vm._v(" "), _c('div', {
    attrs: {
      "align": "center"
    }
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loader),
      expression: "loader"
    }],
    staticClass: "animated preFadeInUp fadeInUp",
    attrs: {
      "align": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "height": "100px"
    },
    attrs: {
      "src": "static/img/ajax-loader.gif"
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    staticStyle: {
      "background-color": "#007d53",
      "color": "white",
      "box-shadow": "0px 2px 10px rgba(0, 0, 0, 0.4)",
      "border-color": "#007d53",
      "width": "127.5px",
      "height": "41px"
    }
  }, [_vm._v("\n                    Submit\n                  ")])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "font-weight": "500",
      "font-size": "14.5px",
      "color": "#232323"
    },
    attrs: {
      "align": "center"
    }
  }, [_c('p', [_vm._v("\n          Welcome to the Multi-Source Data Analytics & Triangulation (MSDAT)\n          "), _c('br'), _vm._v("Platform. The DHPRS Team welcomes your feedback and suggestions.\n        ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "800",
      "font-size": "13.5px",
      "color": "#717171",
      "margin-bottom": "15px"
    },
    attrs: {
      "align": "center"
    }
  }, [_vm._v("\n          Please leave us your feedback and we will be in touch soon.\n        ")])])
}]}

/***/ })

});


// WEBPACK FOOTER //
// static/js/6.8a397249bee5f23a1351.js